const lbaDebtorMultiSelect = angular.module('app.lbaDebtorMultiSelect', []);

lbaDebtorMultiSelect.controller('lbaDebtorMultiSelectCtrl', require('./lbaDebtorMultiSelectCtrl'));
lbaDebtorMultiSelect.directive('lbaDebtorMultiSelect', require('./lbaDebtorMultiSelectDir'));

export default lbaDebtorMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaDebtorMultiSelect/index.js